/*
 * @Author: zhaihaooran
 * @Date: 2021-07-14 11:29:26
 * @LastEditors: wyf
 * @FilePath: /umu_support_modules/packages/common/src/components/@SlidePicker/TimePicker.tsx
 */
import React from 'react';
import '../@timePicker/timePicker.scss';
import { localeConfig } from '../@timePicker/localeConfig';
import Picker from '@umu/umu-picker';
import dayjs from 'dayjs';
import dayjsGenerateConfig from '@umu/umu-picker/lib/generate/dayjs';
import { PICKER_MODE, MODE_SETTING } from './config';

/**
 * API介绍
 *
 * https://ant.design/components/date-picker-cn/
 */
export interface ITimePickerType {
    initValue: dayjs.Dayjs;
    className?: string;
    readonly: boolean;
    showNow: boolean;
    border?: boolean;
    open?: boolean;
    picker?: PICKER_MODE;
    //  设置不可选中日期
    disabledDate?(date: any): void;
    // 设置不可选中时间
    disabledTime?(): void;
    blur?(): void;
    onSelect(value: string): void;
    getPopupContainer?: (triggerNode?: HTMLElement) => HTMLElement;
}

const UMUPicker: any = Picker;

export function TimePicker({
    border = true,
    open = false,
    className,
    picker = PICKER_MODE.DATE,
    onSelect,
    disabledDate,
    disabledTime,
    initValue,
    showNow = false,
    ...rest
}: ITimePickerType) {
    const onSelectVal = (val: dayjs.Dayjs) => {
        const result = dayjs(val).format(MODE_SETTING[picker].format);
        onSelect(result);
    };

    const sharedProps = {
        generateConfig: dayjsGenerateConfig,
        onSelect,
    };

    return (
        <UMUPicker
            {...rest}
            {...sharedProps}
            value={initValue}
            className={className}
            onSelect={onSelectVal}
            locale={localeConfig.locale}
            defaultPickerValue={initValue}
            showTime={false}
            open={open}
            blur={blur}
            format={localeConfig.dateDisplayFormat}
            showToday
            showSecond={false}
            disabledTime={disabledTime}
            disabledDate={disabledDate}
            showNow={showNow}
            picker={picker}
            border={border}
        />
    );
}
